import React, { createContext, useContext } from "react";
import { checkIsEmptyHtmlString } from "repoV2/utils/common/validators/validators";
import { useSalePageContext } from "../SalePageContext";

type IPromotionalStatsSectionContextValue = {
    userCount: { value: string; description: string; hide: boolean };
    rating: {
        value: number;
        maxValue: number;
        description: string;
        hide: boolean;
    };
    hide: boolean;
};

const initialContextValue: IPromotionalStatsSectionContextValue = {
    userCount: {
        value: "",
        description: "",
        hide: false,
    },
    rating: {
        value: 0,
        maxValue: 5,
        description: "",
        hide: false,
    },
    hide: false,
};

const PromotionalStatsSectionContext = createContext(initialContextValue);

export function PromotionalStatsSectionContextProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const { sectionsData, isPreview } = useSalePageContext();

    const userCountBase = {
        value:
            sectionsData.promotionalStatsSection.userCount.value ||
            (isPreview ? "45475" : ""),
        description:
            sectionsData.promotionalStatsSection.userCount.description ||
            (isPreview ? "Have attended the workshop" : ""),
    };
    const userCount = {
        ...userCountBase,
        hide:
            checkIsEmptyHtmlString(userCountBase.value) &&
            checkIsEmptyHtmlString(userCountBase.description),
    };
    const ratingBase = {
        value: Number(
            sectionsData.promotionalStatsSection.rating.value ||
                (isPreview ? "4.1" : "0")
        ),
        description:
            sectionsData.promotionalStatsSection.rating.description ||
            (isPreview ? "Have attended the workshop" : ""),
        maxValue: 5,
    };
    const rating = {
        ...ratingBase,
        hide:
            !ratingBase.value && checkIsEmptyHtmlString(ratingBase.description),
    };
    const contextValue: IPromotionalStatsSectionContextValue = {
        userCount,
        rating,
        hide: userCount.hide && rating.hide,
    };
    return (
        <PromotionalStatsSectionContext.Provider value={contextValue}>
            {children}
        </PromotionalStatsSectionContext.Provider>
    );
}

export function usePromotionalStatsSectionContext() {
    return useContext(PromotionalStatsSectionContext);
}
